import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Spinner, Alert } from "reactstrap";
import { unsubscribeFromPublicSongFlow } from "../../components/helpers/PublicCuratedSongFlowHelpers";

function PublicSongFlowUnsubscribe() {
    const { token } = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [result, setResult] = useState(null);

    useEffect(() => {
        unsubscribeFromPublicSongFlow(token).then(data => {
            setResult(data);
            setIsLoading(false);
        });
    }, [token]);

    return (
        <div className="position-relative">
            <section className="section section-lg section-shaped pb-250">
                <div className="shape shape-style-1 shape-default">
                    <span /><span /><span /><span /><span /><span /><span /><span /><span />
                </div>
                <Container className="py-lg-md d-flex">
                    <div className="col px-0">
                        <Row>
                            <Col lg="8">
                                <h1 className="display-3 text-white">Unsubscribe</h1>
                                <p className="lead text-white">Managing your song-flow email preferences.</p>
                            </Col>
                        </Row>
                    </div>
                </Container>
                <div className="separator separator-bottom separator-skew">
                    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 2560 100">
                        <polygon className="fill-white" points="2560 0 2560 100 0 100" />
                    </svg>
                </div>
            </section>

            <section className="section section-lg pt-lg-0 mt--200">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg="6">
                            <Card className="shadow border-0">
                                <CardBody className="py-5 px-5 text-center">
                                    {isLoading ? (
                                        <Spinner color="primary" />
                                    ) : result && result.success ? (
                                        <div>
                                            <Alert color="success">{result.message}</Alert>
                                            <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                                                You will no longer receive curated song-flow emails from The Worship Bible.
                                            </p>
                                            <Link to="/" className="btn btn-outline-primary mt-2">
                                                Go to The Worship Bible
                                            </Link>
                                        </div>
                                    ) : (
                                        <Alert color="danger">
                                            Something went wrong. Please try again or contact us if this persists.
                                        </Alert>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default PublicSongFlowUnsubscribe;
